import React from 'react';
import { createRoot } from 'react-dom/client';
import { OptionsApp } from '@ext/options/OptionsApp';
import { CancelPage, isCancelPath } from './CancelPage';
import { EnvBadge } from './components/EnvBadge';
import { setUpWebPlatform } from './setUp';

// The public cancel page (§312k BGB) is reachable without signing in, so it is chosen before the
// dashboard and its sign-in gate. It needs none of the dashboard's set-up (no learner data, and
// the set-up empties the browser's copy of the data when there is no session).
if (isCancelPath(window.location.pathname)) {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <CancelPage />
    </React.StrictMode>
  );
} else {
  setUpWebPlatform();

  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <OptionsApp />
      <EnvBadge />
    </React.StrictMode>
  );
}
